<template>
  <div class="slideshow">
    <div class="content">
      <img class="pathfinder" src="/assets/pathfinder.png" />

      <div class="nav" v-show="show">
        <h1>Hinschauen und Handeln 2023</h1>

        <ul>
          <li v-for="(talk, index) in $_talks()" :key="index">
            {{ talk.time }}
            <template v-if="talk.description != null">
              <router-link :to="{ name: 'Talk', params: { id: talk.id } }">
                {{ talk.title }}
              </router-link>
            </template>
            <template v-else>
              {{ talk.title }}
            </template>
            <small v-if="talk.speakerNames.length > 0">
              {{ talk.speakerNames.join(", ") }}
            </small>
          </li>
        </ul>

        <p>
          Moderation:<br />
          Katharina Simon, Gleichstellungsbeauftragte Stadt Kempten
        </p>

        <p>
          Freuen Sie sich auf diese hochkarätigen Vorträge!
        </p>

        <button
          class="tally"
          data-tally-open="mDBlXE"
          data-tally-hide-title="1"
        >
          Jetzt anmelden
        </button>

        <p>
          Die Veranstaltung ist kostenfrei. Eine Anmeldung ist erforderlich.<br />
          Vor Ort gibt es Getränke und Mittagessen zu kaufen.
        </p>

        <p>
          <strong>Veranstaltungsort:</strong>&nbsp;
          <a href="https://www.hs-kempten.de/hochschule/anfahrt-parken-und-campus">Hochschule Kempten</a>,
          Audimax (Gebäude V, ausgeschildert)
        </p>

        <p class="mb-1">
          <router-link to="/sponsors">
            Unsere Unterstützer:innen <br />

            <small>
              Nur durch das Engagement unserer Unterstützer:innen ist diese
              Veranstaltungsreihe möglich
            </small>
          </router-link>
        </p>

        <p class="mb-0">
          Jubiläumsveranstaltung der Kooperationspartnerinnen<br />

          <small>
            Frauenhaus Kempten und Fachberatungsstelle Frauennotruf Kempten
          </small>
        </p>
      </div>

      <div class="partners">
        <a href="https://www.frauenhaus-kempten.de" target="_new">
          <img src="/assets/partner-1.png" />
        </a>
        <a href="https://frauennotruf-kempten-awo.de" target="_new">
          <img src="/assets/partner-2.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Talks",

  data() {
    return { show: true };
  },

  mounted() {
    // setTimeout(() => {
    //   this.show = true;
    // }, 200);
  },
};
</script>

<style scoped>
.nav {
  width: 80% !important;
  height: auto !important;
  padding-left: 1em !important;
  padding-bottom: 1em !important;
}

.nav ul {
  color: #fff;
  padding: 0 2em;
}

.nav li {
  margin-top: 0.25em;
}

.nav a {
  font-weight: bold;
  text-decoration: none;
  color: #eee;
}
.nav li a {
  text-decoration: underline;
}

li small {
  display: block;
  font-size: 90%;
  font-weight: normal !important;
  text-decoration: none !important;
}

.nav a.router-link-exact-active,
.nav a:hover {
  color: #fff;
  text-decoration: underline;
}

.partners {
  padding-left: 1em !important;
  padding-top: 0 !important;
}
.partners * {
  vertical-align: bottom;
  margin-right: 0.2em;
}
.partners small {
  font-size: 0.6em;
  margin-left: 3em;
}
.partners img {
  height: 3.2em;
}

.pathfinder {
  width: 40% !important;
  height: auto !important;
  margin: 3em 1em 0 1em;
  float: right;
}

.tally {
  background-color: #4a8bbd;
  border: none;
  color: #fff;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
}

@media screen and (max-width: 800px) {
  .content {
    min-height: 900px;
  }

  .partners img {
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  li small {
    display: block;
    font-size: 9pt;
  }
}
</style>
